/**
 * The two values the page needs to know about its own project.
 *
 * **Build-time constants, substituted by esbuild's `--define`, not runtime
 * lookups.** A static page has nowhere to read configuration from at runtime
 * that is not another request, and a request to find out where to make requests
 * is a page that fails twice as often.
 *
 * Both are public by design. The anon key ships to the browser and is meant to.
 * It is only *uninteresting* because two other things hold: **RLS restricts
 * every table, and signups are disabled** (PLAN §18). Without either, it
 * is a way into every campaign ever sent — which is why `test/db/rls.test.ts`
 * asserts both rather than trusting them.
 */

declare const __SUPABASE_URL__: string;
declare const __SUPABASE_ANON_KEY__: string;
declare const __MAX_IMPORT_ROWS__: number;
declare const __WARN_IF_PARTS_ABOVE__: number;

export const SUPABASE_URL: string = __SUPABASE_URL__;
export const SUPABASE_ANON_KEY: string = __SUPABASE_ANON_KEY__;

/**
 * The two limits the screens need, and the `campaign` function needs too.
 *
 * **They have to be set in both places, and the deploy notes say so.** If they
 * disagree the panel still behaves correctly — the gate is authoritative, and a
 * refusal it makes is rendered on the screen that allowed it — but somebody
 * gets told at the last moment about a limit the screen never mentioned, which
 * is exactly the kind of surprise this panel is otherwise built to avoid.
 */
export const MAX_IMPORT_ROWS: number = __MAX_IMPORT_ROWS__;

/** A warning, never a block (§59). One segment by default. */
export const WARN_IF_PARTS_ABOVE: number = __WARN_IF_PARTS_ABOVE__;

export const FUNCTIONS_URL = `${SUPABASE_URL.replace(/\/+$/, '')}/functions/v1`;
export const REST_URL = `${SUPABASE_URL.replace(/\/+$/, '')}/rest/v1`;

/** Whether the bundle was built with a project to talk to at all. */
export function configured(): boolean {
  return SUPABASE_URL !== '' && SUPABASE_ANON_KEY !== '';
}
